const translateMessage = (key, messages) => {
  return key && messages ? messages[key] || `Error: String Not Found: ${key}` : '';
};

export {
  translateMessage
}

